import people from '../../data/people';

const leadership = people.filter(({ leadership }) => leadership)
  .reduce((accum, person) => ({
    ...accum,
    [person.key]: person,
  }), {});

export default leadership;
